import { BoolFilter } from "gen/search/service/service_pb"
import { useBoolFilter } from "shared-ts/hooks/useFilter"

import { useWebFilter, UseWebFilterProps } from "hooks/filters/useWebFilter"

export function useStatusFilter({
  persistInUrl = true,
}: Partial<Pick<UseWebFilterProps<unknown>, "persistInUrl">> = {}) {
  return useBoolFilter({
    key: "status",
    label: "Status",
    labelExtractor: (option) =>
      ({
        [BoolFilter.NONE]: "",
        [BoolFilter.TRUE]: "Active",
        [BoolFilter.FALSE]: "Inactive",
      })[option] ?? "",
    useFilter: (props) => useWebFilter({ ...props, persistInUrl }),
  })
}
